import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  loading: false,
  error: null,
};

export const authSlice = createSlice({
  name: "cauth",
  initialState,
  reducers: {
    setLoginData: (state, action) => {
      state.user = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setLoginData, setLoading, setError } = authSlice.actions;

export const getUserData = (state) => state?.cauth?.user;
export const getLoginLoading = (state) => state?.cauth?.loading;
// Selector to get the corporate_id directly
export const getCorporateId = (state) => state?.cauth?.user?.corporate_id;
export default authSlice.reducer;